
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

export default function ErrorDialog({doShowError, handleErrorClose, errorTitle, errorText}) {
    return (
      <Dialog
        open={doShowError}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{errorTitle}</DialogTitle>
        <DialogContent>
          {errorText}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleErrorClose} color="primary" variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
}